import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import SEOHead from './SEOHead';
import Nav from './Nav';
import Footer from './Footer';

function Pricing() {
  const { lang } = useParams();
  const { setLanguage, language } = useLanguage();
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [showModal, setShowModal] = useState(false);

  // Function to get appropriate icon for each feature type
  const getFeatureIcon = (feature, planColorHex) => {
    const lowerFeature = feature.toLowerCase();
    
    if (lowerFeature.includes('upload') || lowerFeature.includes('رفع')) {
      return <i className="fas fa-cloud-upload-alt me-2 mt-1" style={{ color: planColorHex || '#10b981', fontSize: '14px', minWidth: '20px' }}></i>;
    } else if (lowerFeature.includes('transcription minutes') || lowerFeature.includes('دقيقة نسخ')) {
      return <i className="fas fa-clock me-2 mt-1" style={{ color: planColorHex || '#10b981', fontSize: '14px', minWidth: '20px' }}></i>;
    } else if (lowerFeature.includes('file size') || lowerFeature.includes('حجم الملف')) {
      return <i className="fas fa-hdd me-2 mt-1" style={{ color: planColorHex || '#10b981', fontSize: '14px', minWidth: '20px' }}></i>;
    } else if (lowerFeature.includes('youtube') || lowerFeature.includes('يوتيوب')) {
      return <i className="fab fa-youtube me-2 mt-1" style={{ color: planColorHex || '#10b981', fontSize: '14px', minWidth: '20px' }}></i>;
    } else if (lowerFeature.includes('live transcription') || lowerFeature.includes('نسخ مباشر')) {
      return <i className="fas fa-microphone me-2 mt-1" style={{ color: planColorHex || '#10b981', fontSize: '14px', minWidth: '20px' }}></i>;
    } else if (lowerFeature.includes('concurrent') || (lowerFeature.includes('معالجة') && lowerFeature.includes('في نفس الوقت'))) {
      return <i className="fas fa-layer-group me-2 mt-1" style={{ color: planColorHex || '#10b981', fontSize: '14px', minWidth: '20px' }}></i>;
    } else if ((lowerFeature.includes('ai chat') || lowerFeature.includes('الذكاء الاصطناعي')) && (!lowerFeature.includes('powerpoint') && !lowerFeature.includes('image'))) {
      return <i className="fas fa-comments me-2 mt-1" style={{ color: planColorHex || '#10b981', fontSize: '14px', minWidth: '20px' }}></i>;
    } else if (lowerFeature.includes('storage') || lowerFeature.includes('backup') || lowerFeature.includes('تخزين')) {
      return <i className="fas fa-database me-2 mt-1" style={{ color: planColorHex || '#10b981', fontSize: '14px', minWidth: '20px' }}></i>;
    } else if ((lowerFeature.includes('language') || lowerFeature.includes('لغة')) && !lowerFeature.includes('translation')) {
      return <i className="fas fa-globe me-2 mt-1" style={{ color: planColorHex || '#10b981', fontSize: '14px', minWidth: '20px' }}></i>;
    } else if (lowerFeature.includes('powerpoint') || lowerFeature.includes('عرض تقديمي')) {
      return <i className="fas fa-file-powerpoint me-2 mt-1" style={{ color: planColorHex || '#10b981', fontSize: '14px', minWidth: '20px' }}></i>;
    } else if (lowerFeature.includes('image') || lowerFeature.includes('صورة')) {
      return <i className="fas fa-image me-2 mt-1" style={{ color: planColorHex || '#10b981', fontSize: '14px', minWidth: '20px' }}></i>;
    } else if (lowerFeature.includes('text tools') || lowerFeature.includes('أدوات النصوص')) {
      return <i className="fas fa-file-alt me-2 mt-1" style={{ color: planColorHex || '#10b981', fontSize: '14px', minWidth: '20px' }}></i>;
    } else if (lowerFeature.includes('support') || lowerFeature.includes('دعم')) {
      return <i className="fas fa-headset me-2 mt-1" style={{ color: planColorHex || '#10b981', fontSize: '14px', minWidth: '20px' }}></i>;
    } else if (lowerFeature.includes('priority processing') || lowerFeature.includes('معالجة ذات أولوية')) {
      return <i className="fas fa-bolt me-2 mt-1" style={{ color: planColorHex || '#10b981', fontSize: '14px', minWidth: '20px' }}></i>;
    } else if (lowerFeature.includes('max per upload') || lowerFeature.includes('حد أقصى')) {
      return <i className="fas fa-clock me-2 mt-1" style={{ color: planColorHex || '#10b981', fontSize: '14px', minWidth: '20px' }}></i>;
    } else if (lowerFeature.includes('mobile app') || lowerFeature.includes('تطبيق الجوال')) {
      return <i className="fas fa-mobile-alt me-2 mt-1" style={{ color: planColorHex || '#10b981', fontSize: '14px', minWidth: '20px' }}></i>;
    } else if (lowerFeature.includes('translation') || lowerFeature.includes('ترجمة')) {
      return <i className="fas fa-language me-2 mt-1" style={{ color: planColorHex || '#10b981', fontSize: '14px', minWidth: '20px' }}></i>;
    } else if (lowerFeature.includes('api') || lowerFeature.includes('API')) {
      return <i className="fas fa-code me-2 mt-1" style={{ color: planColorHex || '#10b981', fontSize: '14px', minWidth: '20px' }}></i>;
    } else if (lowerFeature.includes('security') || lowerFeature.includes('أمان')) {
      return <i className="fas fa-shield-alt me-2 mt-1" style={{ color: planColorHex || '#10b981', fontSize: '14px', minWidth: '20px' }}></i>;
    } else if (lowerFeature.includes('training') || lowerFeature.includes('تدريب')) {
      return <i className="fas fa-graduation-cap me-2 mt-1" style={{ color: planColorHex || '#10b981', fontSize: '14px', minWidth: '20px' }}></i>;
    } else if (lowerFeature.includes('invoicing') || lowerFeature.includes('فوترة')) {
      return <i className="fas fa-file-invoice me-2 mt-1" style={{ color: planColorHex || '#10b981', fontSize: '14px', minWidth: '20px' }}></i>;
    } else if (lowerFeature.includes('team') || lowerFeature.includes('فرق')) {
      return <i className="fas fa-users me-2 mt-1" style={{ color: planColorHex || '#10b981', fontSize: '14px', minWidth: '20px' }}></i>;
    } else if (lowerFeature.includes('enterprise solutions') || lowerFeature.includes('حلول المؤسسات')) {
      return <i className="fas fa-building me-2 mt-1" style={{ color: planColorHex || '#10b981', fontSize: '14px', minWidth: '20px' }}></i>;
    } else if (lowerFeature.includes('volume-based') || lowerFeature.includes('discount pricing') || lowerFeature.includes('تسعير بالجملة')) {
      return <i className="fas fa-percentage me-2 mt-1" style={{ color: planColorHex || '#10b981', fontSize: '14px', minWidth: '20px' }}></i>;
    } else if (lowerFeature.includes('account manager') || lowerFeature.includes('مدير الحساب')) {
      return <i className="fas fa-user-tie me-2 mt-1" style={{ color: planColorHex || '#10b981', fontSize: '14px', minWidth: '20px' }}></i>;
    } else if (lowerFeature.includes('sla') || lowerFeature.includes('service level agreement') || lowerFeature.includes('اتفاقية مستوى الخدمة')) {
      return <i className="fas fa-handshake me-2 mt-1" style={{ color: planColorHex || '#10b981', fontSize: '14px', minWidth: '20px' }}></i>;
    } else if (lowerFeature.includes('onboarding') || lowerFeature.includes('إعداد')) {
      return <i className="fas fa-rocket me-2 mt-1" style={{ color: planColorHex || '#10b981', fontSize: '14px', minWidth: '20px' }}></i>;
    } else if (lowerFeature.includes('24/7') || lowerFeature.includes('24 ساعة')) {
      return <i className="fas fa-clock me-2 mt-1" style={{ color: planColorHex || '#10b981', fontSize: '14px', minWidth: '20px' }}></i>;
    } else if (lowerFeature.includes('custom solutions') || lowerFeature.includes('حلول مخصصة')) {
      return <i className="fas fa-cogs me-2 mt-1" style={{ color: planColorHex || '#10b981', fontSize: '14px', minWidth: '20px' }}></i>;
    } else {
      // Default icon for other features
      return <i className="fas fa-check me-2 mt-1" style={{ color: planColorHex || '#10b981', fontSize: '14px', minWidth: '20px' }}></i>;
    }
  };

  useEffect(() => {
    if (lang && (lang === 'en' || lang === 'ar')) {
      setLanguage(lang);
    }
  }, [lang, setLanguage]);

  const openModal = (plan) => {
    setSelectedPlan(plan);
    setShowModal(true);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedPlan(null);
    document.body.style.overflow = 'auto';
  };

  const content = {
    en: {
      title: "Pricing Plans - Audiosum AI Audio Transcription & Summarization",
      description: "Choose the perfect Audiosum plan for your needs. From free trials to unlimited access, get accurate AI audio transcription and summarization at affordable prices.",
      keywords: "audiosum pricing, audio transcription plans, AI summarization cost, free trial, pro premium plans",
      
      hero: {
        title: "Choose Your Plan",
        subtitle: "Start with our free trial or upgrade to unlock unlimited transcription power"
      },

      plans: [
        {
          name: "Free Trial",
          subtitle: "Limited features",
          price: "$0",
          period: "/month",
          popular: false,
          colorHex: "#6b7280",
          colorLight: "rgba(107,114,128,0.06)",
          border: "1px solid rgba(107,114,128,0.18)",
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
          features: [
            "10 uploads/month",
            "120 transcription minutes/month",
            "25MB file size limit",
            "60 min max per upload",
            "95+ Languages audio/video uploads",
            "30 min live transcription",
            "AI Chat (24hr trial)",
            "1 AI PowerPoint per month",
            "1 AI Image per month",
            "Text Tools: 5,000 char limit"
          ],
          buttonText: "Current Plan",
          buttonClass: "btn-outline-primary"
        },
        {
          name: "Starter",
          subtitle: "Perfect for individuals",
          price: "$6.99",
          originalPrice: "$11.99",
          period: "/month",
          yearlyPrice: "$69.99",
          yearlySavings: "Save 17%",
          popular: false,
          badge: "BEST VALUE",
          colorHex: "#10b981",
          colorLight: "rgba(16,185,129,0.08)",
          border: "1px solid rgba(16,185,129,0.18)",
          boxShadow: "0 8px 32px rgba(16,185,129,0.12)",
          features: [
            "420 transcription minutes/month",
            "30 uploads/month",
            "500MB file size limit",
            "75 min max per upload",
            "60 live transcription minutes/month",
            "3 concurrent file processing",
            "Unlimited AI Chat access",
            "Permanent storage with backup",
            "95+ language support",
            "1 AI PowerPoint/month",
            "1 AI Image/month",
            "Text Tools: 50,000 char limit"
          ],
          buttonText: "Get Starter",
          buttonClass: "btn-outline-primary"
        },
        {
          name: "Pro",
          subtitle: "Most popular",
          price: "$14.99",
          originalPrice: "$24.99",
          period: "/month",
          yearlyPrice: "$149.99",
          yearlySavings: "Save 17%",
          popular: true,
          colorHex: "#0695FF",
          colorLight: "rgba(6,149,255,0.08)",
          border: "2px solid rgba(6,149,255,0.3)",
          boxShadow: "0 8px 32px rgba(6,149,255,0.18)",
          features: [
            "900 transcription minutes/month",
            "100 uploads/month",
            "750MB file size limit",
            "125 min max per upload",
            "300 live transcription minutes/month",
            "5 concurrent file processing",
            "AI Chat with cross-file analysis",
            "Live Arabic Translation (5 hours/month)",
            "Permanent storage with backup",
            "95+ language support",
            "Advanced summaries + key points extraction",
            "5 AI PowerPoints per month",
            "20 AI Images per month",
            "Text Tools: 100,000 char limit",
            "Priority email support",
            "Mobile app access (coming soon)"
          ],
          buttonText: "Get Pro",
          buttonClass: "btn-primary"
        },
        {
          name: "Premium",
          subtitle: "Unlimited access",
          price: "$28.99",
          originalPrice: "$44.99",
          period: "/month",
          yearlyPrice: "$289.99",
          yearlySavings: "Save 17%",
          popular: false,
          badge: "UNLIMITED",
          colorHex: "#764ba2",
          colorLight: "rgba(118,75,162,0.08)",
          border: "1px solid rgba(118,75,162,0.18)",
          boxShadow: "0 8px 32px rgba(118,75,162,0.12)",
          features: [
            "1,740 transcription minutes/month",
            "Unlimited file uploads",
            "1GB file size limit",
            "125 min max per upload",
            "720 live transcription minutes/month",
            "5 concurrent file processing",
            "AI Chat with cross-file analysis",
            "Permanent storage with backup",
            "95+ language support",
            "Advanced summaries + AI tutor assistance",
            "Priority processing (3x faster)",
            "15 AI PowerPoints per month",
            "50 AI Images per month",
            "Text Tools: 100,000 char limit",
            "Premium priority support",
            "Mobile app access (coming soon)"
          ],
          buttonText: "Get Premium",
          buttonClass: "btn-success"
        },
        {
          name: "Enterprise",
          subtitle: "For large organizations",
          price: "Custom Pricing",
          period: "",
          yearlyPrice: null,
          yearlySavings: null,
          popular: false,
          badge: "CUSTOM",
          colorHex: "#C8A32B",
          colorLight: "rgba(200,163,43,0.08)",
          border: "1px solid rgba(200,163,43,0.18)",
          boxShadow: "0 8px 32px rgba(200,163,43,0.12)",
          features: [
            "Custom enterprise solutions",
            "Volume-based discount pricing",
            "Multiple team accounts",
            "Dedicated account manager",
            "Service Level Agreement (SLA)",
            "Custom API integration",
            "Training & onboarding",
            "Custom invoicing",
            "Advanced security features",
            "24/7 priority support",
            "Custom solutions on demand",
            "Contact Sales"
          ],
          buttonText: "Contact Sales",
          buttonClass: "btn-outline-primary"
        }
      ]
    },
    ar: {
      title: "خطط الأسعار - أوديوسام تحويل الصوت إلى نص بالذكاء الاصطناعي",
      description: "اختر الخطة المثالية لاحتياجاتك مع أوديوسام. من التجربة المجانية إلى الوصول غير المحدود، احصل على تحويل دقيق للصوت إلى نص بأسعار معقولة.",
      keywords: "أسعار أوديوسام, خطط تحويل الصوت, تكلفة الذكاء الاصطناعي, تجربة مجانية, خطط احترافية",
      
      hero: {
        title: "اختر خطتك",
        subtitle: "ابدأ بالتجربة المجانية أو ترقى لفتح قوة التحويل غير المحدودة"
      },

      plans: [
        {
          name: "تجربة مجانية",
          subtitle: "ميزات محدودة",
          price: "$0",
          period: "/شهرياً",
          popular: false,
          colorHex: "#6b7280",
          colorLight: "rgba(107,114,128,0.06)",
          border: "1px solid rgba(107,114,128,0.18)",
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
          features: [
            "10 رفعات شهرياً",
            "120 دقيقة نسخ شهرياً",
            "حد حجم الملف 25 ميجا",
            "60 دقيقة حد أقصى للرفع الواحد",
            "95+ لغة لرفع الصوت/الفيديو",
            "30 دقيقة نسخ مباشر",
            "الذكاء الاصطناعي (تجربة 24 ساعة)",
            "1 عرض تقديمي بالذكاء الاصطناعي شهرياً",
            "1 صورة بالذكاء الاصطناعي شهرياً",
            "أدوات النصوص: حد 5,000 حرف"
          ],
          buttonText: "الخطة الحالية",
          buttonClass: "btn-outline-primary"
        },
        {
          name: "المبتدئ",
          subtitle: "مثالي للأفراد",
          price: "$6.99",
          originalPrice: "$11.99",
          period: "/شهرياً",
          yearlyPrice: "$69.99",
          yearlySavings: "وفر 17%",
          popular: false,
          badge: "BEST VALUE",
          colorHex: "#10b981",
          colorLight: "rgba(16,185,129,0.08)",
          border: "1px solid rgba(16,185,129,0.18)",
          boxShadow: "0 8px 32px rgba(16,185,129,0.12)",
          features: [
            "420 دقيقة نسخ شهرياً",
            "30 رفعة شهرياً",
            "حد حجم الملف 500 ميجا",
            "75 دقيقة حد أقصى للرفع الواحد",
            "60 دقيقة نسخ مباشر شهرياً",
            "معالجة 3 ملفات في نفس الوقت",
            "وصول غير محدود للذكاء الاصطناعي",
            "تخزين دائم مع نسخ احتياطي",
            "دعم 95+ لغة",
            "1 عرض تقديمي بالذكاء الاصطناعي شهرياً",
            "1 صورة بالذكاء الاصطناعي شهرياً",
            "أدوات النصوص: حد 50,000 حرف"
          ],
          buttonText: "احصل على المبتدئ",
          buttonClass: "btn-outline-primary"
        },
        {
          name: "احترافي",
          subtitle: "الأكثر شعبية",
          price: "$14.99",
          originalPrice: "$24.99",
          period: "/شهرياً",
          yearlyPrice: "$149.99",
          yearlySavings: "وفر 17%",
          popular: true,
          colorHex: "#0695FF",
          colorLight: "rgba(6,149,255,0.08)",
          border: "2px solid rgba(6,149,255,0.3)",
          boxShadow: "0 8px 32px rgba(6,149,255,0.18)",
          features: [
            "900 دقيقة نسخ شهرياً",
            "100 رفعة شهرياً",
            "حد حجم الملف 750 ميجا",
            "125 دقيقة حد أقصى للرفع الواحد",
            "300 دقيقة نسخ مباشر شهرياً",
            "معالجة 5 ملفات في نفس الوقت",
            "الذكاء الاصطناعي مع تحليل متعدد الملفات",
            "ترجمة عربية مباشرة (5 ساعات شهرياً)",
            "تخزين دائم مع نسخ احتياطي",
            "دعم 95+ لغة",
            "ملخصات متقدمة + استخراج النقاط الرئيسية",
            "5 عروض تقديمية بالذكاء الاصطناعي شهرياً",
            "20 صورة بالذكاء الاصطناعي شهرياً",
            "أدوات النصوص: حد 100,000 حرف",
            "دعم بريد إلكتروني مُعطى الأولوية",
            "وصول لتطبيق الجوال (قريباً)"
          ],
          buttonText: "احصل على الاحترافي",
          buttonClass: "btn-primary"
        },
        {
          name: "المتميز",
          subtitle: "وصول غير محدود",
          price: "$28.99",
          originalPrice: "$44.99",
          period: "/شهرياً",
          yearlyPrice: "$289.99",
          yearlySavings: "وفر 17%",
          popular: false,
          badge: "غير محدود",
          colorHex: "#764ba2",
          colorLight: "rgba(118,75,162,0.08)",
          border: "1px solid rgba(118,75,162,0.18)",
          boxShadow: "0 8px 32px rgba(118,75,162,0.12)",
          features: [
            "1,740 دقيقة نسخ شهرياً",
            "رفع ملفات غير محدود",
            "حد حجم الملف 1 جيجا",
            "125 دقيقة حد أقصى للرفع الواحد",
            "720 دقيقة نسخ مباشر شهرياً",
            "معالجة 5 ملفات في نفس الوقت",
            "الذكاء الاصطناعي مع تحليل متعدد الملفات",
            "تخزين دائم مع نسخ احتياطي",
            "دعم 95+ لغة",
            "ملخصات متقدمة + مساعدة مدرس ذكي",
            "معالجة ذات أولوية (أسرع 3 مرات)",
            "15 عرض تقديمي بالذكاء الاصطناعي شهرياً",
            "50 صورة بالذكاء الاصطناعي شهرياً",
            "أدوات النصوص: حد 100,000 حرف",
            "دعم متميز ذو أولوية",
            "وصول لتطبيق الجوال (قريباً)"
          ],
          buttonText: "احصل على المتميز",
          buttonClass: "btn-success"
        },
        {
          name: "المؤسسات",
          subtitle: "للمؤسسات الكبيرة",
          price: "تسعير مخصص",
          period: "",
          yearlyPrice: null,
          yearlySavings: null,
          popular: false,
          badge: "مخصص",
          colorHex: "#C8A32B",
          colorLight: "rgba(200,163,43,0.08)",
          border: "1px solid rgba(200,163,43,0.18)",
          boxShadow: "0 8px 32px rgba(200,163,43,0.12)",
          features: [
            "حلول مؤسسية مخصصة",
            "تسعير مخفض حسب الحجم",
            "حسابات فرق متعددة",
            "مدير حساب مخصص",
            "اتفاقية مستوى الخدمة (SLA)",
            "تكامل API مخصص",
            "تدريب وإعداد",
            "فوترة مخصصة",
            "ميزات أمان متقدمة",
            "دعم ذو أولوية على مدار الساعة",
            "حلول مخصصة حسب الطلب",
            "تواصل مع المبيعات"
          ],
          buttonText: "تواصل مع المبيعات",
          buttonClass: "btn-outline-primary"
        }
      ]
    }
  };

  const currentContent = content[language] || content.en;

  return (
    <div>
      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @media (max-width: 768px) {
          .modal-container {
            max-width: 95% !important;
            max-height: 90vh !important;
            overflow-y: auto !important;
          }
          .modal-header-flex {
            flex-direction: column !important;
            text-align: center !important;
          }
          .modal-price-section {
            text-align: center !important;
            margin-top: 15px;
          }
        }
      `}</style>
      
      <SEOHead 
        title={currentContent.title}
        description={currentContent.description}
        keywords={currentContent.keywords}
      />
      <Nav />
      
      {/* Hero Section */}
      <section className="py-5 mt-5" style={{ paddingTop: '100px' }}>
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8">
              <h1 className="display-4 mb-4" style={{ fontFamily: '"Roboto", "Poppins", sans-serif', color: '#ffffff' }}>{currentContent.hero.title}</h1>
              <p className="lead mb-4" style={{ fontFamily: '"Tinos", "Times New Roman", serif', color: '#64748b' }}>{currentContent.hero.subtitle}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Plans */}
      <section className="py-5">
        <div className="container">
          {/* First row: Free, Starter, Pro */}
          <div className="row justify-content-center mb-5 gx-3">
            {currentContent.plans.slice(0, 3).map((plan, index) => (
              <div key={index} className="col-lg-4 col-md-6 mb-4 d-flex justify-content-center">
                <div 
                  className={`card h-100 border-0 position-relative ${plan.popular ? 'border-primary' : ''}`}
                  style={{ 
                    background: plan.colorLight || (plan.popular ? 'rgba(6, 149, 255, 0.1)' : 'rgba(255, 255, 255, 0.05)'),
                    backdropFilter: 'blur(10px)',
                    WebkitBackdropFilter: 'blur(10px)',
                    border: plan.border || (plan.popular ? '2px solid rgba(6, 149, 255, 0.3)' : '1px solid rgba(255, 255, 255, 0.1)'),
                    borderRadius: '24px',
                    boxShadow: plan.boxShadow || '0 8px 32px rgba(0, 0, 0, 0.1)',
                    transform: 'scale(1)',
                    zIndex: 1,
                    transition: 'all 0.3s ease',
                    maxWidth: '380px',
                    width: '100%'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'scale(1.03) translateY(-5px)';
                    e.currentTarget.style.boxShadow = plan.colorHex 
                      ? `0 20px 60px rgba(${parseInt(plan.colorHex.slice(1,3), 16)}, ${parseInt(plan.colorHex.slice(3,5), 16)}, ${parseInt(plan.colorHex.slice(5,7), 16)}, 0.4), 0 0 40px rgba(${parseInt(plan.colorHex.slice(1,3), 16)}, ${parseInt(plan.colorHex.slice(3,5), 16)}, ${parseInt(plan.colorHex.slice(5,7), 16)}, 0.3)`
                      : '0 20px 60px rgba(0, 0, 0, 0.2)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                    e.currentTarget.style.boxShadow = plan.boxShadow || '0 8px 32px rgba(0, 0, 0, 0.1)';
                  }}
                >
                  {plan.popular && (
                    <div className="position-absolute top-0 end-0" style={{ transform: 'translate(-10px, -50%)' }}>
                      <span className="badge px-3 py-2" style={{ 
                        borderRadius: '20px',
                        background: plan.colorHex || '#0695FF',
                        boxShadow: `0 4px 15px ${plan.colorHex ? 'rgba(0,0,0,0.14)' : 'rgba(6, 149, 255, 0.4)'}`
                      }}>
                        POPULAR
                      </span>
                    </div>
                  )}
                  
                  {plan.badge && (
                    <div className="position-absolute top-0 end-0" style={{ transform: 'translate(-10px, -50%)' }}>
                      <span className="badge px-3 py-2" style={{ borderRadius: '15px', background: plan.colorHex || undefined, boxShadow: '0 4px 10px rgba(0,0,0,0.2)' }}>
                        {plan.badge}
                      </span>
                    </div>
                  )}

                  <div className="card-header text-center border-0 bg-transparent pt-4 pb-0">
                    <h3 className="fw-bold mb-2" style={{ color: '#ffffff' }}>{plan.name}</h3>
                    <p className="mb-3" style={{ color: '#e2e8f0' }}>{plan.subtitle}</p>
                    <div className="mb-3" style={{ minHeight: '120px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                      {plan.originalPrice && (
                        <div className="mb-1">
                          <span className="text-decoration-line-through" style={{ color: '#94a3b8', fontSize: '18px' }}>
                            {plan.originalPrice}
                          </span>
                          <span className="badge bg-danger ms-2" style={{ fontSize: '11px', padding: '4px 8px' }}>
                            {language === 'ar' ? 'خصم' : 'SAVE'}
                          </span>
                        </div>
                      )}
                      <div>
                        <span className={plan.price === "Custom Pricing" || plan.price === "تسعير مخصص" ? "h4 fw-bold" : "display-5 fw-bold"} style={{ color: '#ffffff' }}>{plan.price}</span>
                        <span style={{ color: '#94a3b8' }}>{plan.period}</span>
                      </div>
                      {plan.yearlyPrice && (
                        <p className="small mb-0 mt-2" style={{ color: '#94a3b8' }}>
                          or {plan.yearlyPrice}/year ({plan.yearlySavings})
                        </p>
                      )}
                    </div>
                  </div>

                  <div className="card-body">
                    <button
                      onClick={() => openModal(plan)}
                      className="btn w-100 mb-3"
                      style={{
                        background: plan.colorLight || 'rgba(6, 149, 255, 0.1)',
                        border: plan.border || '1px solid rgba(6, 149, 255, 0.3)',
                        borderRadius: '12px',
                        color: plan.colorHex || '#0695FF',
                        fontWeight: '600',
                        padding: '12px',
                        transition: 'all 0.3s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.background = plan.colorLight || 'rgba(6, 149, 255, 0.16)';
                        e.target.style.borderColor = plan.colorHex || 'rgba(6, 149, 255, 0.5)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.background = plan.colorLight || 'rgba(6, 149, 255, 0.1)';
                        e.target.style.borderColor = plan.colorHex || 'rgba(6, 149, 255, 0.3)';
                      }}
                    >
                      <i className="fas fa-list-ul me-2"></i>
                      {language === 'ar' ? 'عرض المزايا' : 'View Benefits'}
                    </button>
                  </div>

                  <div className="card-footer text-center border-0 bg-transparent pb-4">
                    <a
                      href={plan.buttonText === "Contact Sales" || plan.buttonText === "تواصل مع المبيعات" 
                        ? `/${language === 'ar' ? 'ar' : 'en'}/contact` 
                        : `https://audiosum.app/signup?lang=${language}&plan=${plan.name.toLowerCase().replace(' ', '-')}`}
                      target={plan.buttonText === "Contact Sales" || plan.buttonText === "تواصل مع المبيعات" ? "_self" : "_blank"}
                      rel="noopener noreferrer"
                      className={`btn btn-lg w-100 py-3`}
                      style={{ 
                        borderRadius: '15px', 
                        fontWeight: '600',
                        background: plan.popular ? (plan.colorHex || '#0695FF') : (plan.colorLight || 'rgba(6, 149, 255, 0.1)'),
                        border: plan.popular ? 'none' : (plan.border || '1px solid rgba(6, 149, 255, 0.3)'),
                        color: plan.popular ? '#ffffff' : (plan.colorHex || '#0695FF'),
                        transition: 'all 0.3s ease',
                        boxShadow: plan.popular ? (plan.boxShadow ? plan.boxShadow : '0 4px 15px rgba(6, 149, 255, 0.4)') : 'none'
                      }}
                      onMouseEnter={(e) => {
                        if (plan.popular) {
                          e.target.style.background = plan.colorHex || '#0578D6';
                          e.target.style.boxShadow = '0 6px 20px rgba(0,0,0,0.2)';
                        } else {
                          e.target.style.background = plan.colorLight || 'rgba(6, 149, 255, 0.2)';
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (plan.popular) {
                          e.target.style.background = plan.colorHex || '#0695FF';
                          e.target.style.boxShadow = plan.boxShadow ? plan.boxShadow : '0 4px 15px rgba(6, 149, 255, 0.4)';
                        } else {
                          e.target.style.background = plan.colorLight || 'rgba(6, 149, 255, 0.1)';
                        }
                      }}
                    >
                      {plan.buttonText}
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Power Users Section - Premium and Enterprise */}
          {currentContent.plans.length > 3 && (
            <>
              <div className="text-center" style={{ marginTop: '60px', marginBottom: '100px' }}>
                <h2 className="fw-bold mb-3" style={{ color: '#ffffff', fontSize: '32px' }}>
                  {language === 'ar' ? 'للمستخدمين المحترفين' : 'Power Users'}
                </h2>
                <p style={{ color: '#94a3b8', fontSize: '16px', marginBottom: '0' }}>
                  {language === 'ar' ? 'خطط متقدمة للاستخدام المكثف والشركات' : 'Advanced plans for heavy usage and businesses'}
                </p>
              </div>
              
              <div className="row justify-content-center mb-4 gx-1">
                {currentContent.plans.slice(3, 5).map((plan, index) => (
                  <div key={index} className="col-lg-6 col-md-6 mb-4 d-flex justify-content-center">
                    <div 
                      className={`card h-100 border-0 position-relative ${plan.popular ? 'border-primary' : ''}`}
                      style={{ 
                        background: plan.colorLight || (plan.popular ? 'rgba(6, 149, 255, 0.1)' : 'rgba(255, 255, 255, 0.05)'),
                        backdropFilter: 'blur(10px)',
                        WebkitBackdropFilter: 'blur(10px)',
                        border: plan.border || (plan.popular ? '2px solid rgba(6, 149, 255, 0.3)' : '1px solid rgba(255, 255, 255, 0.1)'),
                        borderRadius: '24px',
                        boxShadow: plan.boxShadow || '0 8px 32px rgba(0, 0, 0, 0.1)',
                        transform: 'scale(1)',
                        zIndex: 1,
                        transition: 'all 0.3s ease',
                        maxWidth: '380px',
                        width: '100%'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'scale(1.03) translateY(-5px)';
                        e.currentTarget.style.boxShadow = plan.colorHex 
                          ? `0 20px 60px rgba(${parseInt(plan.colorHex.slice(1,3), 16)}, ${parseInt(plan.colorHex.slice(3,5), 16)}, ${parseInt(plan.colorHex.slice(5,7), 16)}, 0.4), 0 0 40px rgba(${parseInt(plan.colorHex.slice(1,3), 16)}, ${parseInt(plan.colorHex.slice(3,5), 16)}, ${parseInt(plan.colorHex.slice(5,7), 16)}, 0.3)`
                          : '0 20px 60px rgba(0, 0, 0, 0.2)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'scale(1)';
                        e.currentTarget.style.boxShadow = plan.boxShadow || '0 8px 32px rgba(0, 0, 0, 0.1)';
                      }}
                    >
                      {plan.popular && (
                        <div className="position-absolute top-0 end-0" style={{ transform: 'translate(-10px, -50%)' }}>
                          <span className="badge px-3 py-2" style={{ 
                            borderRadius: '20px',
                            background: plan.colorHex || '#0695FF',
                            boxShadow: `0 4px 15px ${plan.colorHex ? 'rgba(0,0,0,0.14)' : 'rgba(6, 149, 255, 0.4)'}`
                          }}>
                            POPULAR
                          </span>
                        </div>
                      )}
                      
                      {plan.badge && (
                        <div className="position-absolute top-0 end-0" style={{ transform: 'translate(-10px, -50%)' }}>
                          <span className="badge px-3 py-2" style={{ borderRadius: '15px', background: plan.colorHex || undefined, boxShadow: '0 4px 10px rgba(0,0,0,0.2)' }}>
                            {plan.badge}
                          </span>
                        </div>
                      )}

                      <div className="card-header text-center border-0 bg-transparent pt-4 pb-0">
                        <h3 className="fw-bold mb-2" style={{ color: '#ffffff' }}>{plan.name}</h3>
                        <p className="mb-3" style={{ color: '#e2e8f0' }}>{plan.subtitle}</p>
                        <div className="mb-3" style={{ minHeight: '120px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                          {plan.originalPrice && (
                            <div className="mb-1">
                              <span className="text-decoration-line-through" style={{ color: '#94a3b8', fontSize: '18px' }}>
                                {plan.originalPrice}
                              </span>
                              <span className="badge bg-danger ms-2" style={{ fontSize: '11px', padding: '4px 8px' }}>
                                {language === 'ar' ? 'خصم' : 'SAVE'}
                              </span>
                            </div>
                          )}
                          <div>
                            <span className={plan.price === "Custom Pricing" || plan.price === "تسعير مخصص" ? "h4 fw-bold" : "display-5 fw-bold"} style={{ color: '#ffffff' }}>{plan.price}</span>
                            <span style={{ color: '#94a3b8' }}>{plan.period}</span>
                          </div>
                          {plan.yearlyPrice && (
                            <p className="small mb-0 mt-2" style={{ color: '#94a3b8' }}>
                              or {plan.yearlyPrice}/year ({plan.yearlySavings})
                            </p>
                          )}
                        </div>
                      </div>

                      <div className="card-body">
                        <button
                          onClick={() => openModal(plan)}
                          className="btn w-100 mb-3"
                          style={{
                            background: plan.colorLight || 'rgba(6, 149, 255, 0.1)',
                            border: plan.border || '1px solid rgba(6, 149, 255, 0.3)',
                            borderRadius: '12px',
                            color: plan.colorHex || '#0695FF',
                            fontWeight: '600',
                            padding: '12px',
                            transition: 'all 0.3s ease'
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.background = plan.colorLight || 'rgba(6, 149, 255, 0.16)';
                            e.target.style.borderColor = plan.colorHex || 'rgba(6, 149, 255, 0.5)';
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.background = plan.colorLight || 'rgba(6, 149, 255, 0.1)';
                            e.target.style.borderColor = plan.colorHex || 'rgba(6, 149, 255, 0.3)';
                          }}
                        >
                          <i className="fas fa-list-ul me-2"></i>
                          {language === 'ar' ? 'عرض المزايا' : 'View Benefits'}
                        </button>
                      </div>

                      <div className="card-footer text-center border-0 bg-transparent pb-4">
                        <a
                          href={plan.buttonText === "Contact Sales" || plan.buttonText === "تواصل مع المبيعات" 
                            ? `/${language === 'ar' ? 'ar' : 'en'}/contact` 
                            : `https://audiosum.app/signup?lang=${language}&plan=${plan.name.toLowerCase().replace(' ', '-')}`}
                          target={plan.buttonText === "Contact Sales" || plan.buttonText === "تواصل مع المبيعات" ? "_self" : "_blank"}
                          rel="noopener noreferrer"
                          className={`btn btn-lg w-100 py-3`}
                          style={{ 
                            borderRadius: '15px', 
                            fontWeight: '600',
                            background: plan.popular ? (plan.colorHex || '#0695FF') : (plan.colorLight || 'rgba(6, 149, 255, 0.1)'),
                            border: plan.popular ? 'none' : (plan.border || '1px solid rgba(6, 149, 255, 0.3)'),
                            color: plan.popular ? '#ffffff' : (plan.colorHex || '#0695FF'),
                            transition: 'all 0.3s ease',
                            boxShadow: plan.popular ? (plan.boxShadow ? plan.boxShadow : '0 4px 15px rgba(6, 149, 255, 0.4)') : 'none'
                          }}
                          onMouseEnter={(e) => {
                            if (plan.popular) {
                              e.target.style.background = plan.colorHex || '#0578D6';
                              e.target.style.boxShadow = '0 6px 20px rgba(0,0,0,0.2)';
                            } else {
                              e.target.style.background = plan.colorLight || 'rgba(6, 149, 255, 0.2)';
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (plan.popular) {
                              e.target.style.background = plan.colorHex || '#0695FF';
                              e.target.style.boxShadow = plan.boxShadow ? plan.boxShadow : '0 4px 15px rgba(6, 149, 255, 0.4)';
                            } else {
                              e.target.style.background = plan.colorLight || 'rgba(6, 149, 255, 0.1)';
                            }
                          }}
                        >
                          {plan.buttonText}
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}

          {/* Features Comparison - Added padding-top */}
          <div className="row" style={{ marginTop: '100px', paddingTop: '60px' }}>
            <div className="col-12">
              <div className="text-center mb-5">
                <h2 className="h3 fw-bold mb-3">Why Choose Audiosum?</h2>
                <p className="lead mb-5" style={{ color: '#64748b' }}>All plans include our core AI-powered features</p>
              </div>
              
              <div className="row">
                <div className="col-md-4 mb-4">
                  <div style={{
                    background: 'rgba(102, 126, 234, 0.08)',
                    backdropFilter: 'blur(10px)',
                    WebkitBackdropFilter: 'blur(10px)',
                    border: '1px solid rgba(102, 126, 234, 0.2)',
                    borderRadius: '20px',
                    padding: '2rem',
                    boxShadow: '0 8px 32px rgba(102, 126, 234, 0.15)',
                    textAlign: 'center',
                    transition: 'all 0.3s ease',
                    height: '100%'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-5px)';
                    e.currentTarget.style.boxShadow = '0 12px 40px rgba(102, 126, 234, 0.25)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 8px 32px rgba(102, 126, 234, 0.15)';
                  }}>
                    <div style={{
                      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                      borderRadius: '50%',
                      width: '60px',
                      height: '60px',
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginBottom: '1rem',
                      boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)'
                    }}>
                      <i className="fas fa-brain text-white fa-lg"></i>
                    </div>
                    <h5 className="fw-bold" style={{ color: '#667eea' }}>AI-Powered Accuracy</h5>
                    <p style={{ color: '#ffffff', marginBottom: 0 }}>Industry-leading transcription accuracy with advanced AI models</p>
                  </div>
                </div>
                
                <div className="col-md-4 mb-4">
                  <div style={{
                    background: 'rgba(16, 185, 129, 0.08)',
                    backdropFilter: 'blur(10px)',
                    WebkitBackdropFilter: 'blur(10px)',
                    border: '1px solid rgba(16, 185, 129, 0.2)',
                    borderRadius: '20px',
                    padding: '2rem',
                    boxShadow: '0 8px 32px rgba(16, 185, 129, 0.15)',
                    textAlign: 'center',
                    transition: 'all 0.3s ease',
                    height: '100%'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-5px)';
                    e.currentTarget.style.boxShadow = '0 12px 40px rgba(16, 185, 129, 0.25)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 8px 32px rgba(16, 185, 129, 0.15)';
                  }}>
                    <div style={{
                      background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                      borderRadius: '50%',
                      width: '60px',
                      height: '60px',
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginBottom: '1rem',
                      boxShadow: '0 4px 15px rgba(16, 185, 129, 0.3)'
                    }}>
                      <i className="fas fa-globe text-white fa-lg"></i>
                    </div>
                    <h5 className="fw-bold" style={{ color: '#10b981' }}>95+ Languages</h5>
                    <p style={{ color: '#ffffff', marginBottom: 0 }}>Support for multiple languages and regional dialects</p>
                  </div>
                </div>
                
                <div className="col-md-4 mb-4">
                  <div style={{
                    background: 'rgba(245, 158, 11, 0.08)',
                    backdropFilter: 'blur(10px)',
                    WebkitBackdropFilter: 'blur(10px)',
                    border: '1px solid rgba(245, 158, 11, 0.2)',
                    borderRadius: '20px',
                    padding: '2rem',
                    boxShadow: '0 8px 32px rgba(245, 158, 11, 0.15)',
                    textAlign: 'center',
                    transition: 'all 0.3s ease',
                    height: '100%'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-5px)';
                    e.currentTarget.style.boxShadow = '0 12px 40px rgba(245, 158, 11, 0.25)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 8px 32px rgba(245, 158, 11, 0.15)';
                  }}>
                    <div style={{
                      background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                      borderRadius: '50%',
                      width: '60px',
                      height: '60px',
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginBottom: '1rem',
                      boxShadow: '0 4px 15px rgba(245, 158, 11, 0.3)'
                    }}>
                      <i className="fas fa-shield-alt text-white fa-lg"></i>
                    </div>
                    <h5 className="fw-bold" style={{ color: '#f59e0b' }}>Secure & Private</h5>
                    <p style={{ color: '#ffffff', marginBottom: 0 }}>Your files are encrypted and processed securely</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* FAQ Section */}
          <div className="row" style={{ marginTop: '120px' }}>
            <div className="col-lg-8 mx-auto">
              <div className="text-center mb-5">
                <h2 className="h3 fw-bold">Frequently Asked Questions</h2>
              </div>
              
              <div className="accordion" id="pricingFAQ">
                <div className="accordion-item border-0 mb-3" style={{ 
                  borderRadius: '15px', 
                  overflow: 'hidden',
                  background: 'rgba(255, 255, 255, 0.05)',
                  backdropFilter: 'blur(10px)',
                  border: '1px solid rgba(255, 255, 255, 0.1)'
                }}>
                  <h3 className="accordion-header" id="headingOne">
                    <button 
                      className="accordion-button collapsed" 
                      type="button" 
                      onClick={(e) => {
                        const target = document.querySelector('#faq1');
                        const button = e.target;
                        if (target.classList.contains('show')) {
                          target.classList.remove('show');
                          button.classList.add('collapsed');
                        } else {
                          document.querySelectorAll('.accordion-collapse').forEach(item => {
                            item.classList.remove('show');
                          });
                          document.querySelectorAll('.accordion-button').forEach(btn => {
                            btn.classList.add('collapsed');
                          });
                          target.classList.add('show');
                          button.classList.remove('collapsed');
                        }
                      }}
                      style={{ 
                        background: 'rgba(255, 255, 255, 0.05)', 
                        backdropFilter: 'blur(10px)',
                        border: 'none',
                        color: '#ffffff',
                        fontWeight: '600'
                      }}
                    >
                      Can I cancel my subscription anytime?
                    </button>
                  </h3>
                  <div id="faq1" className="accordion-collapse collapse">
                    <div className="accordion-body" style={{ 
                      background: 'rgba(255, 255, 255, 0.03)', 
                      backdropFilter: 'blur(10px)',
                      color: '#e2e8f0' 
                    }}>
                      Yes, you can cancel your subscription at any time. Your access will continue until the end of your billing period.
                    </div>
                  </div>
                </div>
                
                <div className="accordion-item border-0 mb-3" style={{ 
                  borderRadius: '15px', 
                  overflow: 'hidden',
                  background: 'rgba(255, 255, 255, 0.05)',
                  backdropFilter: 'blur(10px)',
                  border: '1px solid rgba(255, 255, 255, 0.1)'
                }}>
                  <h3 className="accordion-header" id="headingTwo">
                    <button 
                      className="accordion-button collapsed" 
                      type="button" 
                      onClick={(e) => {
                        const target = document.querySelector('#faq2');
                        const button = e.target;
                        if (target.classList.contains('show')) {
                          target.classList.remove('show');
                          button.classList.add('collapsed');
                        } else {
                          document.querySelectorAll('.accordion-collapse').forEach(item => {
                            item.classList.remove('show');
                          });
                          document.querySelectorAll('.accordion-button').forEach(btn => {
                            btn.classList.add('collapsed');
                          });
                          target.classList.add('show');
                          button.classList.remove('collapsed');
                        }
                      }}
                      style={{ 
                        background: 'rgba(255, 255, 255, 0.05)', 
                        backdropFilter: 'blur(10px)',
                        border: 'none',
                        color: '#ffffff',
                        fontWeight: '600'
                      }}
                    >
                      What file formats are supported?
                    </button>
                  </h3>
                  <div id="faq2" className="accordion-collapse collapse">
                    <div className="accordion-body" style={{ 
                      background: 'rgba(255, 255, 255, 0.03)', 
                      backdropFilter: 'blur(10px)',
                      color: '#e2e8f0' 
                    }}>
                      We support all major audio and video formats including MP3, WAV, M4A, MP4, AVI, MOV, and many more.
                    </div>
                  </div>
                </div>
                
                <div className="accordion-item border-0 mb-3" style={{ 
                  borderRadius: '15px', 
                  overflow: 'hidden',
                  background: 'rgba(255, 255, 255, 0.05)',
                  backdropFilter: 'blur(10px)',
                  border: '1px solid rgba(255, 255, 255, 0.1)'
                }}>
                  <h3 className="accordion-header" id="headingThree">
                    <button 
                      className="accordion-button collapsed" 
                      type="button" 
                      onClick={(e) => {
                        const target = document.querySelector('#faq3');
                        const button = e.target;
                        if (target.classList.contains('show')) {
                          target.classList.remove('show');
                          button.classList.add('collapsed');
                        } else {
                          document.querySelectorAll('.accordion-collapse').forEach(item => {
                            item.classList.remove('show');
                          });
                          document.querySelectorAll('.accordion-button').forEach(btn => {
                            btn.classList.add('collapsed');
                          });
                          target.classList.add('show');
                          button.classList.remove('collapsed');
                        }
                      }}
                      style={{ 
                        background: 'rgba(255, 255, 255, 0.05)', 
                        backdropFilter: 'blur(10px)',
                        border: 'none',
                        color: '#ffffff',
                        fontWeight: '600'
                      }}
                    >
                      Is there a free trial available?
                    </button>
                  </h3>
                  <div id="faq3" className="accordion-collapse collapse">
                    <div className="accordion-body" style={{ 
                      background: 'rgba(255, 255, 255, 0.03)', 
                      backdropFilter: 'blur(10px)',
                      color: '#e2e8f0' 
                    }}>
                      Yes! Our free trial offers 10 uploads and/or 120 transcription minutes per month, plus 30 live transcription minutes to help you experience our platform.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="row" style={{ marginTop: '120px', marginBottom: '120px' }}>
            <div className="col-lg-8 mx-auto text-center">
              <div style={{
                background: 'rgba(6, 149, 255, 0.08)',
                backdropFilter: 'blur(10px)',
                WebkitBackdropFilter: 'blur(10px)',
                border: '1px solid rgba(6, 149, 255, 0.2)',
                borderRadius: '24px',
                padding: '3rem',
                boxShadow: '0 8px 32px rgba(6, 149, 255, 0.15), 0 0 60px rgba(6, 149, 255, 0.1)',
                position: 'relative',
                overflow: 'hidden'
              }}>
                {/* Decorative gradient blob */}
                <div style={{
                  position: 'absolute',
                  top: '-50%',
                  right: '-20%',
                  width: '300px',
                  height: '300px',
                  background: 'radial-gradient(circle, rgba(6, 149, 255, 0.15) 0%, transparent 70%)',
                  borderRadius: '50%',
                  filter: 'blur(40px)',
                  zIndex: 0
                }}></div>
                <div style={{
                  position: 'absolute',
                  bottom: '-30%',
                  left: '-10%',
                  width: '250px',
                  height: '250px',
                  background: 'radial-gradient(circle, rgba(118, 75, 162, 0.1) 0%, transparent 70%)',
                  borderRadius: '50%',
                  filter: 'blur(40px)',
                  zIndex: 0
                }}></div>
                
                <div style={{ position: 'relative', zIndex: 1 }}>
                  <h2 className="h3 fw-bold mb-4" style={{ color: '#0695FF' }}>Ready to Get Started?</h2>
                  <p className="lead mb-4" style={{ color: '#ffffff' }}>Join thousands of users who trust Audiosum for accurate audio transcription</p>
                  
                  {/* Button Container with Flex */}
                  <div className="d-flex flex-column flex-md-row justify-content-center align-items-center gap-3">
                    <a 
                      href={`https://audiosum.app/signup?lang=${language}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-lg px-5 py-3"
                      style={{ 
                        fontSize: '1.1rem',
                        borderRadius: '50px',
                        background: '#0695FF',
                        border: 'none',
                        boxShadow: '0 8px 30px rgba(6, 149, 255, 0.4)',
                        color: 'white',
                        fontWeight: '600',
                        textDecoration: 'none',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        transition: 'all 0.3s ease',
                        width: '220px'
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.boxShadow = '0 12px 40px rgba(6, 149, 255, 0.5)';
                        e.currentTarget.style.background = '#0578D6';
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0 8px 30px rgba(6, 149, 255, 0.4)';
                        e.currentTarget.style.background = '#0695FF';
                      }}
                    >
                      <i className="fas fa-rocket me-2"></i>
                      Start Free
                    </a>
                    <a 
                      href={`/${language}/contact`}
                      className="btn btn-lg px-5 py-3"
                      style={{ 
                        fontSize: '1.1rem',
                        borderRadius: '50px',
                        background: 'rgba(255, 255, 255, 0.1)',
                        border: '2px solid rgba(255, 255, 255, 0.3)',
                        color: 'white',
                        fontWeight: '600',
                        textDecoration: 'none',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backdropFilter: 'blur(10px)',
                        transition: 'all 0.3s ease',
                        width: '220px'
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.background = 'rgba(255, 255, 255, 0.2)';
                        e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.5)';
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
                        e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.3)';
                      }}
                    >
                      Contact Sales
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Modal */}
      {showModal && selectedPlan && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.85)',
            backdropFilter: 'blur(5px)',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px',
            animation: 'fadeIn 0.3s ease'
          }}
          onClick={closeModal}
        >
          <div
            className="modal-container"
            style={{
              background: 'linear-gradient(135deg, rgba(15, 23, 42, 0.95) 0%, rgba(30, 41, 59, 0.95) 100%)',
              borderRadius: '24px',
              maxWidth: '900px',
              width: '100%',
              maxHeight: '85vh',
              overflow: 'hidden',
              boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5), 0 0 100px rgba(6, 149, 255, 0.15)',
              border: selectedPlan.border || (selectedPlan.popular ? '2px solid rgba(6, 149, 255, 0.5)' : '1px solid rgba(255, 255, 255, 0.1)'),
              animation: 'slideUp 0.3s ease',
              position: 'relative',
              display: 'flex',
              flexDirection: 'column'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close button */}
            <button
              onClick={closeModal}
              style={{
                position: 'absolute',
                top: '20px',
                right: '20px',
                background: 'rgba(255, 255, 255, 0.1)',
                border: 'none',
                borderRadius: '50%',
                width: '40px',
                height: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                color: '#ffffff',
                fontSize: '20px',
                transition: 'all 0.3s ease',
                zIndex: 1
              }}
              onMouseEnter={(e) => {
                e.target.style.background = 'rgba(239, 68, 68, 0.2)';
                e.target.style.transform = 'rotate(90deg)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'rgba(255, 255, 255, 0.1)';
                e.target.style.transform = 'rotate(0deg)';
              }}
            >
              <i className="fas fa-times"></i>
            </button>

            {/* Modal Header */}
            <div className="modal-header-flex" style={{
              padding: '30px 40px 20px 40px',
              borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              flexWrap: 'wrap',
              position: 'relative'
            }}>
              <div style={{ flex: '1', minWidth: '250px' }}>
                {selectedPlan.popular && (
                  <div style={{ marginBottom: '10px' }}>
                    <span className="badge px-3 py-2" style={{ 
                      borderRadius: '20px',
                      background: selectedPlan.colorHex || '#0695FF',
                      boxShadow: selectedPlan.boxShadow ? '0 4px 15px rgba(0,0,0,0.14)' : '0 4px 15px rgba(6, 149, 255, 0.4)',
                      fontSize: '11px'
                    }}>
                      POPULAR
                    </span>
                  </div>
                )}
                {selectedPlan.badge && (
                  <div style={{ marginBottom: '10px' }}>
                    <span className="badge px-3 py-2" style={{ 
                      borderRadius: '15px', 
                      fontSize: '11px',
                      background: selectedPlan.colorHex || '#10b981'
                    }}>
                      {selectedPlan.badge}
                    </span>
                  </div>
                )}
                <h2 className="fw-bold mb-2" style={{ color: '#ffffff', fontSize: '28px' }}>
                  {selectedPlan.name}
                </h2>
                <p className="mb-0" style={{ color: '#94a3b8', fontSize: '14px' }}>
                  {selectedPlan.subtitle}
                </p>
              </div>
              <div className="modal-price-section" style={{ textAlign: language === 'ar' ? 'left' : 'right' }}>
                <div className="mb-1">
                  <span className="fw-bold" style={{ color: '#ffffff', fontSize: '36px' }}>
                    {selectedPlan.price}
                  </span>
                  <span style={{ color: '#64748b', fontSize: '16px' }}>
                    {selectedPlan.period}
                  </span>
                </div>
                {selectedPlan.yearlyPrice && (
                  <p className="small mb-0" style={{ color: '#64748b', fontSize: '13px' }}>
                    {language === 'ar' ? 'أو' : 'or'} {selectedPlan.yearlyPrice}/{language === 'ar' ? 'سنة' : 'year'} ({selectedPlan.yearlySavings})
                  </p>
                )}
              </div>
            </div>

            {/* Modal Body - Features List */}
            <div style={{ padding: '25px 40px', flex: '1', overflowY: 'auto' }}>
              <h4 className="fw-bold mb-3" style={{ color: '#ffffff', fontSize: '18px' }}>
                {language === 'ar' ? 'الميزات المتضمنة:' : 'Included Features:'}
              </h4>
              <div className="row">
                {selectedPlan.features.map((feature, index) => {
                  const halfLength = Math.ceil(selectedPlan.features.length / 2);
                  const isFirstColumn = index < halfLength;
                  
                  return (
                    <div key={index} className="col-md-6 mb-2 d-none d-md-block" style={{ display: isFirstColumn || window.innerWidth < 768 ? 'block' : 'none' }}>
                      <div className="d-flex align-items-start">
                        {feature.startsWith('❌') ? (
                          <i className="fas fa-times me-2 mt-1" style={{ color: '#ef4444', fontSize: '14px', minWidth: '20px' }}></i>
                        ) : feature.startsWith('⏰') ? (
                          <i className="fas fa-clock me-2 mt-1" style={{ color: '#f59e0b', fontSize: '14px', minWidth: '20px' }}></i>
                        ) : (
                          getFeatureIcon(feature, selectedPlan.colorHex)
                        )}
                        <span style={{ 
                          color: feature.startsWith('❌') ? '#64748b' : feature.startsWith('⏰') ? '#fbbf24' : '#e2e8f0',
                          textDecoration: feature.startsWith('❌') ? 'line-through' : 'none',
                          fontSize: '14px',
                          lineHeight: '1.5'
                        }}>
                          {feature.startsWith('❌') ? feature.substring(2) : feature.startsWith('⏰') ? feature.substring(2) : feature}
                        </span>
                      </div>
                    </div>
                  );
                })}
              </div>
              {/* Mobile: Single column */}
              <div className="d-md-none">
                {selectedPlan.features.map((feature, index) => (
                  <div key={index} className="mb-2 d-flex align-items-start">
                    {feature.startsWith('❌') ? (
                      <i className="fas fa-times me-2 mt-1" style={{ color: '#ef4444', fontSize: '14px', minWidth: '20px' }}></i>
                    ) : feature.startsWith('⏰') ? (
                      <i className="fas fa-clock me-2 mt-1" style={{ color: '#f59e0b', fontSize: '14px', minWidth: '20px' }}></i>
                    ) : (
                      getFeatureIcon(feature, selectedPlan.colorHex)
                    )}
                    <span style={{ 
                      color: feature.startsWith('❌') ? '#64748b' : feature.startsWith('⏰') ? '#fbbf24' : '#e2e8f0',
                      textDecoration: feature.startsWith('❌') ? 'line-through' : 'none',
                      fontSize: '14px',
                      lineHeight: '1.5'
                    }}>
                      {feature.startsWith('❌') ? feature.substring(2) : feature.startsWith('⏰') ? feature.substring(2) : feature}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            {/* Modal Footer - CTA Button */}
            <div style={{
              padding: '20px 40px 30px 40px',
              borderTop: '1px solid rgba(255, 255, 255, 0.1)'
            }}>
              <a
                href={selectedPlan.buttonText === "Contact Sales" || selectedPlan.buttonText === "تواصل مع المبيعات" 
                  ? `/${language === 'ar' ? 'ar' : 'en'}/contact` 
                  : `https://audiosum.app/signup?lang=${language}&plan=${selectedPlan.name.toLowerCase().replace(' ', '-')}`}
                target={selectedPlan.buttonText === "Contact Sales" || selectedPlan.buttonText === "تواصل مع المبيعات" ? "_self" : "_blank"}
                rel="noopener noreferrer"
                className="btn btn-lg w-100"
                style={{ 
                  borderRadius: '15px', 
                  fontWeight: '600',
                  padding: '16px',
                  fontSize: '18px',
                  background: selectedPlan.popular ? '#0695FF' : 'rgba(6, 149, 255, 0.15)',
                  border: selectedPlan.popular ? 'none' : '2px solid rgba(6, 149, 255, 0.4)',
                  color: '#ffffff',
                  transition: 'all 0.3s ease',
                  boxShadow: selectedPlan.popular ? '0 4px 20px rgba(6, 149, 255, 0.4)' : 'none',
                  textDecoration: 'none',
                  display: 'block',
                  textAlign: 'center'
                }}
                onMouseEnter={(e) => {
                  if (selectedPlan.popular) {
                    e.target.style.background = '#0578D6';
                    e.target.style.boxShadow = '0 6px 25px rgba(6, 149, 255, 0.5)';
                  } else {
                    e.target.style.background = 'rgba(6, 149, 255, 0.25)';
                    e.target.style.borderColor = 'rgba(6, 149, 255, 0.6)';
                  }
                  e.target.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  if (selectedPlan.popular) {
                    e.target.style.background = '#0695FF';
                    e.target.style.boxShadow = '0 4px 20px rgba(6, 149, 255, 0.4)';
                  } else {
                    e.target.style.background = 'rgba(6, 149, 255, 0.15)';
                    e.target.style.borderColor = 'rgba(6, 149, 255, 0.4)';
                  }
                  e.target.style.transform = 'translateY(0)';
                }}
              >
                {selectedPlan.buttonText}
              </a>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}

export default Pricing;